import uuid from 'powtoon-commons/utils/uuid'
import {pick} from 'lodash'
import {getMinTimeStep} from 'powtoon-html-studio/src/common/utils/timeStep'

export default function lib2SoundItem(libraryItem, extraSoundItemData = {}, extraPlaybackSettings = {}) {
  const {startTime = 0, endTime = libraryItem.length} = extraSoundItemData

  return {
    id: uuid(),
    contentItemId: libraryItem.contentItemId || libraryItem.id,
    audioType: libraryItem.audioType,
    itemType: libraryItem.itemType,
    enterEffect: 'None',
    exitEffect: 'None',
    playbackSettings: {
      baseVolume: 1,
      ...extraPlaybackSettings,
      startTime: extraPlaybackSettings.startTime || 0,
      endTime: extraPlaybackSettings.endTime || Math.min(endTime - startTime, libraryItem.length) || getMinTimeStep()
    },
    ...pick(libraryItem, 'assetType'),
    ...extraSoundItemData
  }
}
